import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { IUserSlice } from '@/redux/slices/user/types';

export const updateCartItem = createAsyncThunk(
  'user/updateCartItem',
  async ({
    id,
    slug,
    data,
  }: {
    id: string | number;
    slug: string;
    data: any;
  }) =>
    await axios({
      method: 'PUT',
      url: slug,
      data,
    }).then((res) => res.data)
);

const pending = (state: IUserSlice, action) => {
  state.cart.items = state.cart.items.map((item) => {
    if (item.id === action.meta.arg.id) {
      item.loading = true;
    }
    return item;
  });
};

const rejected = (state: IUserSlice, { meta }: { meta: any }) => {
  state.cart.items = state.cart.items.map((item) => {
    if (item.id === meta.arg.id) {
      item.loading = false;
    }
    return item;
  });
};

export default {
  action: updateCartItem,
  pending,
  rejected,
};
